import { latestVersion } from './latestVersion';
import { venues } from './venues';

export const decoders = {
  latestVersion,
  venues,
};
